export default __webpack_public_path__ + "static/media/modern-grotesque-times.46f7acee.png";